<template>
  <div class="page routes">
    <div class="title_line flex flex-row justify-between items-center">
      <h2>Routes</h2>
      <div v-if="isRouteListTab" class="inline-block flex w-2/3 justify-end button_group">
        <button class="text-white flex items-center button_text in_row_button full_green_button">
          <router-link to="/plan-v2" class="flex items-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4V19.9996" stroke="white" stroke-width="2" stroke-linecap="round"/>
              <path d="M20 12L4.00038 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span class="h-full">Add Route</span>
          </router-link>
        </button>
        <div class="relative inline-flex shrink-0 manage_menu_wrap">
          <button
            type="button"
            @click="show_manage = !show_manage"
            class="flex items-center in_row_button square_button square_green_button"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="3.5" r="2.5" fill="#1FBC2F"/>
              <circle cx="12" cy="12" r="2.5" fill="#1FBC2F"/>
              <circle cx="12" cy="20.5" r="2.5" fill="#1FBC2F"/>
            </svg>
          </button>
          <div v-if="show_manage" class="manage_group">
            <button type="button" @click="openCsvUploadFromMenu" class="block manage_menu_item">
              Upload CSV
            </button>
            <button
              type="button"
              title="View route import example"
              class="block manage_menu_item w-full text-left"
              @click="openRoutesImportTemplateFromMenu"
            >
              Example
            </button>
          </div>
        </div>
        <VueJsonToCsv
          v-if="checkedItems.length"
          :json-data="exportRoutes"
          :labels="exportCsvLabels"
          csv-title="routes-export"
        >
          <button class="flex items-center in_row_button square_button square_green_button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7 10L12 15L17 10" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 15V3" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </VueJsonToCsv>
        <button
          v-if="checkedItems.length"
          @click="shareManyRoutes()"
          data-tip="Share route"
          class="btn btn-secondary text-primary flex justify-center items-center"
          currentitem="false"
        >
          <span class="mr-1">
            <svg stroke="#1FBC2F" fill="#1FBC2F" stroke-width="0" viewBox="0 0 24 24" size="20" height="20" width="20"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"></path></svg>
          </span>
        </button>
      </div>
    </div>

    <div class="tabs flex items-center justify-center mt-4 mb-4">
      <div class="tabs-wrap flex">
        <button
          type="button"
          class="font-bold"
          :class="{ 'active underline bold-green text-primary': active_tab === 'planned', 'text-grey-darker': active_tab !== 'planned' }"
          @click="switchTab('planned')"
        >
          Planned routes
        </button>
        <span class="ml-2 mr-2">|</span>
        <button
          type="button"
          class="font-bold"
          :class="{ 'active underline bold-green text-primary': active_tab === 'imported', 'text-grey-darker': active_tab !== 'imported' }"
          @click="switchTab('imported')"
        >
          Imported routes
        </button>
        <span class="ml-2 mr-2">|</span>
        <button
          type="button"
          class="font-bold"
          :class="{ 'active underline bold-green text-primary': active_tab === 'mobile', 'text-grey-darker': active_tab !== 'mobile' }"
          @click="switchTab('mobile')"
        >
          Mobile routes
        </button>
      </div>
    </div>

    <div class="filters px-4" v-if="isRouteListTab">
      <FiltersDop
        :names="names"
        :selected_name="selected_name"
        :items_count="routes_count"
        :rows_length="routes.length"
      />
    </div>

    <div class="filters px-4" v-if="isMobileTab">
      <FiltersDop
        :names="mobile_names"
        :selected_name="mobile_selected_name"
        :items_count="mobile_routes_count"
        :rows_length="mobile_routes.length"
      />
    </div>

    <div class="routes_table fl_table mt-4 px-4" v-if="isRouteListTab">
      <div class="wrap" v-if="routes">
        <div class="header py-3 px-2 flex text-left w-full">
          <div class="name flex items-center gap-10p w-1/12">
            <span class="pt-2 px-2">
              <input type="checkbox" @click="checkAll()" v-model="isCheckAll">
            </span>
            <div class="item flex items-center justify-between" @click="sortItems('id')">id
              <span class="sort" :class="{ hidden: !sort_names.id, rotate: ascending }">
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="item flex items-center justify-between w-1/6" @click="sortItems('name')">
            <span class="capitalize px-6">name</span>
            <span class="sort" :class="{ hidden: !sort_names.name, rotate: ascending }">
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
              </svg>
            </span>
          </div>
          <div class="item flex items-center justify-between w-1/6" @click="sortItems('origin')">
            <span class="capitalize">origin</span>
            <span class="sort" :class="{ hidden: !sort_names.origin, rotate: ascending }">
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
              </svg>
            </span>
          </div>
          <div class="item flex items-center justify-between w-1/6" @click="sortItems('last_dropoff')">
            <span class="capitalize">last dropoff</span>
            <span class="sort" :class="{ hidden: !sort_names.last_dropoff, rotate: ascending }">
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
              </svg>
            </span>
          </div>
          <div class="item flex items-center justify-between w-1/12" @click="sortItems('driver_id')">
            <span class="capitalize">driver name</span>
            <span class="sort" :class="{ hidden: !sort_names.driver_id, rotate: ascending }">
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
              </svg>
            </span>
          </div>
          <div class="item flex items-center justify-between w-1/12" @click="sortItems('created_at')">
            <span class="capitalize">Creation Date</span>
            <span class="sort" :class="{ hidden: !sort_names.created_at, rotate: ascending }">
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
              </svg>
            </span>
          </div>
          <div class="item flex items-center justify-between w-1/12">
            <span class="capitalize">Start date</span>
          </div>
          <div v-if="isPlannedTab" class="item flex items-center justify-between w-1/12">
            <span class="capitalize">Source</span>
          </div>
          <div class="item w-1/6"></div>
        </div>
        <div class="body py-2">
          <div v-for="(route, index) in routes" :key="index" class="py-5 px-2 flex text-left">
            <div class="flex items-center w-full">
              <div class="name flex items-center w-1/12 gap-10p">
                <span class="pt-2 px-2">
                  <input type="checkbox" :value="route.id" v-model="checkedItems" @change="updateCheckAll()">
                </span>
                <a v-if="route.route_version === 'v1'" :href="'/routes/' + route.id" class="flex items-center green_text gap-10p">
                  <span>
                    <svg width="16" height="16" fill="none"><path d="M4 6.5a5.47 5.47 0 0 0 1 3.18l-.51.44-.9.26L0 13.46 1.8 15l3.6-3.08.3-.77.39-.33A5.5 5.5 0 1 0 4 6.5zm5.5-4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" fill="#1FBC2F"></path></svg>
                  </span>
                  <span class="green_text">{{ route.id }}</span>
                </a>
                <a v-else :href="'/routes-v2/' + route.id" class="flex items-center green_text gap-10p">
                  <span>
                    <svg width="16" height="16" fill="none"><path d="M4 6.5a5.47 5.47 0 0 0 1 3.18l-.51.44-.9.26L0 13.46 1.8 15l3.6-3.08.3-.77.39-.33A5.5 5.5 0 1 0 4 6.5zm5.5-4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" fill="#1FBC2F"></path></svg>
                  </span>
                  <span class="green_text">{{ route.id }}</span>
                </a>
              </div>
              <div class="name w-1/6 px-6">{{ route.name }}</div>
              <div class="name w-1/6">{{ route.origin }}</div>
              <div class="name w-1/6">{{ route.last_dropoff }}</div>
              <div class="name w-1/12"><span v-if="route.driver">{{ route.driver.name }}</span></div>
              <div class="name w-1/12">{{ route.created_at | moment('DD-MM-YYYY') }}</div>
              <div class="name w-1/12">{{ route.route_info.time_start | moment('DD-MM-YYYY') }}</div>
              <div v-if="isPlannedTab" class="name w-1/12">{{ formatImportSource(route) }}</div>
              <div class="actions w-1/6 flex items-center justify-around">
                <button @click="openShareWindow(route.id)" title="Share route" class="no-underline text-grey-dark hover:text-primary inline-flex regenerate-route-btn" tabindex="-1">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" width="24" height="24" viewBox="0 0 24 24"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"></path></svg>
                </button>
                <button v-if="route.route_version === 'v1'" @click="rePlanV1Route(route.id)" class="my-tooltip no-underline text-grey-dark hover:text-primary inline-flex regenerate-route-btn" title="Replan" tabindex="-1">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" width="24" height="24" viewBox="0 0 24 24"><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"></path></svg>
                  <span class="tooltiptext">Replan</span>
                </button>
                <button v-if="route.route_version === 'v2'" @click="rePlanRoute(route.id)" class="my-tooltip no-underline text-grey-dark hover:text-primary inline-flex regenerate-route-btn" title="Duplicate route" tabindex="-1">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" width="24" height="24" viewBox="0 0 24 24"><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"></path></svg>
                  <span class="tooltiptext">Replan</span>
                </button>
                <button @click="printRoute(route.id, route.route_version)" title="Print route" class="no-underline text-grey-dark hover:text-primary inline-flex regenerate-route-btn" tabindex="-1">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" width="24" height="24" viewBox="0 0 24 24"><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"></path></svg>
                </button>
                <button @click="toDelete(route.id)" class="no-underline text-grey-dark hover:text-primary inline-flex regenerate-route-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6H8V4Z" stroke="#F2374D" stroke-width="2"></path><path d="M3 6H21" stroke="#F2374D" stroke-width="2" stroke-linecap="round"></path><path d="M6.33 20.1867L5 6H19L17.67 20.1867C17.5736 21.2144 16.711 22 15.6787 22H8.32127C7.28902 22 6.42635 21.2144 6.33 20.1867Z" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 18L9.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 18L14.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ShareRoutes v-if="getShowShareRoutes && shareOneRoute" :ids="shareItem" />
      <ShareRoutes v-if="getShowShareRoutes && !shareOneRoute" :ids="checkedItems" />
      <DeleteModal :entity="'route'" v-on:delete-select="deleteRoute" v-on:delete-close="closeDelete" ref="delete_modal"/>
    </div>

    <div class="routes_table fl_table mt-4 px-4" v-if="isMobileTab">
      <div class="wrap">
        <div class="header py-3 px-2 flex text-left w-full">
          <div class="item flex items-center justify-between w-1/12" @click="sortMobileItems('id')">
            <span class="capitalize">Trip ID</span>
          </div>
          <div class="item flex items-center justify-between w-1/12" @click="sortMobileItems('created_at')">
            <span class="capitalize">Creation Date</span>
          </div>
          <div class="item flex items-center justify-between w-2/12">
            <span class="capitalize">Start time</span>
          </div>
          <div class="item flex items-center justify-between w-2/12">
            <span class="capitalize">Expected end time</span>
          </div>
          <div class="item flex items-center justify-between w-1/12" @click="sortMobileItems('driver_id')">
            <span class="capitalize">driver name</span>
          </div>
          <div class="item flex items-center justify-between w-1/12">
            <span class="capitalize">Versions</span>
          </div>
          <div class="item flex items-center justify-between w-1/12">
            <span class="capitalize">duration</span>
          </div>
          <div class="item flex items-center justify-between w-2/12">
            <span class="capitalize">vehicle dimensions</span>
          </div>
          <div class="item w-1/12"><span class="capitalize">Map</span></div>
        </div>
        <div class="body py-2">
          <div v-for="(route, index) in mobile_routes" :key="'mobile-' + index" class="py-5 px-2 flex text-left">
            <div class="flex items-center w-full">
              <div class="name w-1/12">
                <router-link :to="'/mobile-routes/' + (route.trip_id || route.id)" class="green_text">{{ route.trip_id || route.id }}</router-link>
              </div>
              <div class="name w-1/12">{{ route.created_at | moment('DD-MM-YYYY') }}</div>
              <div class="name w-2/12">{{ route.created_at | moment('DD-MM-YYYY HH:mm') }}</div>
              <div class="name w-2/12">{{ formatExpectedEndTime(route) }}</div>
              <div class="name w-1/12">{{ route.driver_name || '-' }}</div>
              <div class="name w-1/12">{{ route.version_count || 1 }}</div>
              <div class="name w-1/12">{{ formatRouteDuration(route) }}</div>
              <div class="name w-2/12">
                H: {{ formatDim(getRouteDimension(route, 'height')) }} m,
                W: {{ formatDim(getRouteDimension(route, 'width')) }} m,
                L: {{ formatDim(getRouteDimension(route, 'length')) }} m,
                Wt: {{ formatDim(getRouteDimension(route, 'weight')) }} t
              </div>
              <div class="actions w-1/12 flex items-center">
                <router-link :to="'/mobile-routes/' + (route.trip_id || route.id)" class="text-grey-dark hover:text-primary inline-flex regenerate-route-btn" title="View route on map">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" width="24" height="24" viewBox="0 0 24 24"><path d="M12 6c-3.79 0-7.17 2.13-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5C19.17 8.13 15.79 6 12 6zm0 9c-1.93 0-3.5-1.57-3.5-3.5S10.07 8 12 8s3.5 1.57 3.5 3.5S13.93 15 12 15zm0-5.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4z"></path></svg>
                </router-link>
              </div>
            </div>
          </div>
          <div v-if="!mobile_routes.length" class="py-5 px-2 text-grey-dark">
            No mobile routes found.
          </div>
        </div>
      </div>
    </div>

    <div class="blocked" v-if="show_manage" @click="closeManageMenu"></div>

    <CSVUploadRoutes
      v-if="isRouteListTab && upload_csv"
      @cancel="onCsvUploadDismiss"
      @import-complete="onRoutesCsvImportComplete"
      @open-template="openRoutesImportTemplate"
    />

    <RoutesImportTemplateModal
      v-if="showRoutesImportTemplate"
      @close="showRoutesImportTemplate = false"
    />
  </div>
</template>

<script>

import moment from 'moment';
import ShareRoutes from '../../components/ShareRoutes';
import {mapGetters, mapMutations} from "vuex";
import {infoMessage} from "@/services/messages";
import DeleteModal from "@/components/DeleteModal";
import FiltersDop from "@/components/FiltersDop";
import VueJsonToCsv from 'vue-json-to-csv';
import CSVUploadRoutes from "@/components/CSVUploadRoutes";
import RoutesImportTemplateModal from "@/components/RoutesImportTemplateModal";

export default {
  name: "Routes",
  data() {
    return {
      showRoutesImportTemplate: false,
      checkedItems: [],
      exportRoutes: [],
      exportColumns: [],
      shareItem: [],
      shareOneRoute: true,
      isCheckAll: false,
      upload_csv: false,
      show_manage: false,
      routes: [],
      routes_count: null,
      mobile_routes: [],
      mobile_routes_count: null,
      active_tab: 'planned',
      route: null,
      id_to_delete: null,
      sort_names: {
        id: false,
        name: false,
        origin: false,
        last_dropoff: false,
        driver_id: false,
        created_at: false,
      },
      ascending: false,
      names:[
        {
          name: 'Route name',
          id: 'name'
        },
        {
          name: 'Route id',
          id: 'id'
        }
      ],
      selected_name: {name: 'Route name', id: 'name'},
      mobile_names: [
        {
          name: 'Route id',
          id: 'id',
        },
        {
          name: 'Driver name',
          id: 'driver_id',
        }
      ],
      mobile_selected_name: {name: 'Route id', id: 'id'},
    }
  },
  methods: {
    closeManageMenu() {
      this.show_manage = false;
    },
    openCsvUploadFromMenu() {
      this.closeManageMenu();
      this.openCsvUpload();
    },
    openRoutesImportTemplateFromMenu() {
      this.closeManageMenu();
      this.openRoutesImportTemplate();
    },
    openRoutesImportTemplate() {
      this.showRoutesImportTemplate = true;
    },
    openCsvUpload() {
      this.upload_csv = true;
    },
    onCsvUploadDismiss() {
      this.upload_csv = false;
      this.fetchByTab();
    },
    onRoutesCsvImportComplete() {
      this.upload_csv = false;
      this.active_tab = 'imported';
      this.$router
        .replace({ path: '/routes', query: { tab: 'imported' } })
        .catch(() => null);
      this.fetchByTab();
    },
    switchTab(tab) {
      this.active_tab = tab;
      let query = {};
      if (tab === 'mobile') {
        query = { tab: 'mobile' };
      } else if (tab === 'imported') {
        query = { tab: 'imported' };
      }
      this.$router.replace({ path: '/routes', query }).catch(() => null);
      this.upload_csv = false;
      this.show_manage = false;
      if (this.isMobileTab) {
        this.checkedItems = [];
      }
      this.fetchByTab();
    },
    fetchByTab(sortBy = 'id') {
      if (this.isRouteListTab) {
        return this.getRoutes(sortBy);
      }
      return this.getMobileRoutes(sortBy);
    },
    formatImportSource(route) {
      return route?.import_source === 'csv' ? 'Imported' : 'Manual';
    },
    formatDim(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      return value;
    },
    formatRouteDuration(route) {
      if (route && route.duration) {
        return route.duration;
      }
      return '-';
    },
    formatExpectedEndTime(route) {
      if (!route || !route.created_at) {
        return '-';
      }
      var durationSeconds = route.duration_seconds;
      if (!durationSeconds || durationSeconds <= 0) {
        return '-';
      }
      return moment(route.created_at)
        .add(durationSeconds, 'seconds')
        .format('DD-MM-YYYY HH:mm');
    },
    getRouteDimension(route, key) {
      if (!route || !route.dimensions) {
        return null;
      }
      return route.dimensions[key];
    },
    ...mapMutations([
      'setShowUpdatePassPopup',
      'setShowShareRoutes'
    ]),
    async resetPasswordPopup(route){
      this.route = route
      this.setShowUpdatePassPopup(true);
    },
    async openShareWindow(id) {
      this.shareItem = true;
      this.shareItem = [];
      this.shareItem.push(id);
      this.shareOneRoute = true;
      this.setShowShareRoutes(true)
    },
    shareManyRoutes() {
      this.shareItem = false;
      this.shareOneRoute = false;
      this.setShowShareRoutes(true)
    },
    checkAll: function(){
      this.isCheckAll = !this.isCheckAll;
      this.checkedItems = [];
      if(this.isCheckAll){
        let j = this;
        this.routes.forEach(route => {
          j.checkedItems.push(route.id);
        })
      }
    },
    updateCheckAll: function(){
      if(this.checkedItems.length == this.routes.length){
        this.isCheckAll = true;
      }else{
        this.isCheckAll = false;
      }
    },
    async sortItems(name) {
      const j = this.sort_names;

      Object.keys(j).forEach(sort_name => {
        j[sort_name] = false;
      })
      this.ascending = !this.ascending;
      this.sort_names[name] = true
      await this.getRoutes(name)
    },
    async sortMobileItems(name) {
      this.ascending = !this.ascending;
      await this.getMobileRoutes(name);
    },
    toDelete(id){
      this.id_to_delete = id;
      this.$refs.delete_modal.show = true;

    },
    closeDelete() {
      this.delete_id = null;
    },
    async deleteRoute() {
      try {
        await this.$http.deleteAuth(`${this.$http.apiUrl()}/routes/${this.id_to_delete}`);
      } catch (e) {
        console.log(e);
        return infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      }

      infoMessage(
          `Route deleted`,
          this.getTopBanner ? 'success open_top_banner' : 'success'
      );

      await this.getRoutes();
    },
    async copyRoute(id) {
      try {
        await this.$http.postAuth(`${this.$http.apiUrl()}/routes/copy/${id}`);
      } catch (e) {
        console.log(e);
        return infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      }

      infoMessage(
          `Route copied`,
          this.getTopBanner ? 'success open_top_banner' : 'success'
      );
      await this.getRoutes();
    },

    rePlanRoute(id) {
      this.$router.push({name: 'HereRePlan', query: {replan_route_id: id}})
    },
    rePlanV1Route(id) {
      this.$router.push({name: 'Plan', query: {replan_route_id: id}})
    },
    async printRoute(id, version) {
      if(version == "v2")
        return await this.$router.push({name: "RoutePrintV2", params: {id}});
      await this.$router.push({path: '/routes/' + id + '/print'})
    },
    async loadExportRoutes() {
      if (!this.checkedItems.length) {
        this.exportRoutes = [];
        this.exportColumns = [];
        return;
      }
      try {
        const response = await this.$http.postAuth(
          `${this.$http.apiUrl()}/routes/export-csv`,
          this.checkedItems,
        );
        this.exportColumns = response?.data?.columns || [];
        this.exportRoutes = response?.data?.rows || [];
        const skipped = response?.data?.skipped || [];
        if (skipped.length) {
          infoMessage(
            `${skipped.length} route(s) could not be exported for CSV import`,
            this.getTopBanner ? 'error open_top_banner' : 'error',
          );
        }
      } catch (e) {
        console.error(e);
        this.exportRoutes = [];
        this.exportColumns = [];
        infoMessage(
          'Could not prepare routes export',
          this.getTopBanner ? 'error open_top_banner' : 'error',
        );
      }
    },
    async getRoutes(sortBy = 'id') {
      this.routes = [];
      try {
        const requestData = {
          skip: this.getRowsToShift || 0,
          take: this.getItemsToShow || 5,
          sort: sortBy,
          search: this.getSearchItemsNames || '',
          ascending: this.ascending,
        }
        let url = `${this.$http.apiUrl()}/routes?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`;
        if (this.active_tab === 'imported') {
          url += '&import_source=csv';
        }
        const response = await this.$http.getAuth(url);

        this.routes = response?.data?.data || null;
        this.routes_count = response?.data?.count || null;
        if (this.getShareNewRouteId) {
          await this.openShareWindow(this.getShareNewRouteId)
        }
      } catch (e) {
        console.log(e);
      }
    }
    ,
    async getMobileRoutes(sortBy = 'id') {
      this.mobile_routes = [];
      try {
        const requestData = {
          skip: this.getRowsToShift || 0,
          take: this.getItemsToShow || 5,
          sort: sortBy,
          search: this.getSearchItemsNames || '',
          ascending: this.ascending,
        };
        const response = await this.$http.getAuth(
          `${this.$http.apiUrl()}/routes-log?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`,
        );

        this.mobile_routes = response?.data?.data || [];
        this.mobile_routes_count = response?.data?.count || 0;
      } catch (e) {
        console.log(e);
      }
    },
  },
  async mounted() {
    const tab = this.$route.query.tab;
    if (tab === 'mobile' || tab === 'imported') {
      this.active_tab = tab;
    } else {
      this.active_tab = 'planned';
    }
    await this.fetchByTab();
  },
  computed: {
    isPlannedTab() {
      return this.active_tab === 'planned';
    },
    isImportedTab() {
      return this.active_tab === 'imported';
    },
    isMobileTab() {
      return this.active_tab === 'mobile';
    },
    exportCsvLabels() {
      const labels = {};
      (this.exportColumns || []).forEach((col) => {
        labels[col] = { title: col };
      });
      return labels;
    },
    isRouteListTab() {
      return this.isPlannedTab || this.isImportedTab;
    },
    ...mapGetters([
      'getItemsToShow',
      'getSelectedFilterItem',
      'getRowsToShift',
      'getSearchItemsNames',
      'getShowShareRoutes',
      'getShareNewRouteId'
    ]),
  },
  components: {
    ShareRoutes,
    DeleteModal,
    FiltersDop,
    VueJsonToCsv,
    CSVUploadRoutes,
    RoutesImportTemplateModal,
  },
  watch: {
    getItemsToShow() {
      this.fetchByTab()
    },
    checkedItems() {
      if (this.isRouteListTab) {
        this.loadExportRoutes();
      }
    },
    getSelectedFilterItem() {
      this.fetchByTab()
    },
    getRowsToShift() {
      this.fetchByTab()
    },
    getSearchItemsNames() {
      this.fetchByTab()
    },
  }
}
</script>

<style lang="scss" scoped>
.item {
  font-size: 14px;
  padding-right: 25px;
}
.name {
  font-size: 14px;
}
.green_text {
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  color: #1FBC2F !important;
}
.actions {
  &:hover, &:active, &:focus{
    .hidden {
      display: block;
    }
    span {
      &>* {
        cursor: pointer;
      }
      &:first-child {
        &>*{
          margin-left: auto;
        }
      }
    }
  }
}
.tabs-wrap button {
  background: transparent;
}
.button_group {
  position: relative;

  .manage_menu_wrap {
    .manage_group {
      z-index: 99;
      position: absolute;
      top: 48px;
      right: 0;
      border-radius: 8px;
      box-sizing: border-box;
      border: 0.5px solid #D8C3AF;
      box-shadow: 5px 5px rgba(216, 195, 175, 0.5);
      padding: 10px;
      background-color: #FFFFFF;
      white-space: nowrap;
    }

    .manage_menu_item {
      display: block;
      margin: 10px;
      padding: 0;
      background: none;
      border: none;
      font: inherit;
      text-align: left;
      cursor: pointer;
      color: #000000;
    }

    .manage_menu_link {
      text-decoration: none;
    }
  }
}
.page.routes {
  overflow-x: hidden;
}
.blocked {
  position: fixed;
  inset: 0;
  z-index: 98;
}
</style>
